import { render, staticRenderFns } from "./qualification.vue?vue&type=template&id=86ce32d2&scoped=true"
import script from "./qualification.vue?vue&type=script&lang=js"
export * from "./qualification.vue?vue&type=script&lang=js"
import style0 from "./qualification.vue?vue&type=style&index=0&id=86ce32d2&prod&lang=scss"
import style1 from "./qualification.vue?vue&type=style&index=1&id=86ce32d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ce32d2",
  null
  
)

export default component.exports